
import Vue from 'vue'

export default Vue.extend({
  methods: {
    clickCard() {
      this.$emit('clickCard')
    }
  }
})
